export enum RemainingResolution {
    RemoveProduct = "remove_product",
    IgnoreRemaining = "ignore_remaining",
    ReduceToRemaining = "reduce_to_remaining",
}

export type CheckoutDiffItem = {
    barcode: string;
    productName: string;
    priceChanged?: {
        oldPrice: number;
        newPrice: number;
    };
    insufficientRemaining?: {
        orderedCount: number;
        remaining: number;
    };
};
